export default "/static/dashboard/build/app/img/v2/fda84c72480a6d413d805359c09c7a26.png";